// Anything exported from this file is importable by other in-browser modules.
import Watchdog from './watchdog/watchdog.component'
import EmojiPicker from './emoji-picker/emoji-picker'
import { mapTypeToIcons } from './utils/activity-types'
import UseLinkInterceptor from '@/utils/commonFunction'

export { Watchdog, EmojiPicker, mapTypeToIcons, UseLinkInterceptor }

import packageJson from '../package.json'
import { Logger } from '@Techedge/digitalportal-shared'

Logger._packageInfo(
	packageJson.name,
	packageJson.version,
	process.env.REACT_APP_ENV,
	process.env.NODE_ENV,
	'purple',
	'white'
)

import { TableConfigService } from './utils/tableConfigService'
import { useTableConfig } from './utils/useTableConfigHook'

export { TableConfigService as TableConfigApi, useTableConfig }
